<style lang="scss">
.request-call-page {
  &__title {
    @include mobile-portrait() {
      margin-top: 25px !important;
    }
  }
}
</style>

<!-- eslint-disable -->
<template>
  <div class="theme-color-wrapper p-2">
    <div class="request-call-page row max-page-width-small mb-4">
      <div class="col-12">
        <section class="waiting-room-page__title mb-3">
          <h2 class="font-weight-bolder mb-1">Request a call</h2>

          <router-link :to="{ name: 'dashboard' }">
            &laquo; Back to calls
          </router-link>
        </section>

        <section v-if="!loading">
          <section v-if="prison">
            <request-call-contacts v-if="stage === 1"></request-call-contacts>
            <request-call-wings v-if="stage === 2"></request-call-wings>
            <request-call-booking-slot v-if="stage === 3"></request-call-booking-slot>
            <request-call-confirm v-if="stage === 4"></request-call-confirm>
          </section>
          <section v-else>
            <p>Cannot find your establishment details, please refresh and try again</p>
          </section>

        </section>

        <section v-else>
          <b-spinner variant="primary" label="Loading"></b-spinner>
        </section>
      </div>
    </div>
  </div>
</template>
<!-- eslint-enable -->

<script>
import { mapState } from 'vuex';
import RequestCallContacts from '@/views/requestCall/sections/RequestCallContacts.vue';
import RequestCallWings from '@/views/requestCall/sections/RequestCallWings.vue';
import RequestCallBookingSlot from '@/views/requestCall/sections/RequestCallBookingSlot.vue';
import RequestCallConfirm from '@/views/requestCall/sections/RequestCallConfirm.vue';

export default {
  name: 'RequestCall',
  components: {
    RequestCallContacts,
    RequestCallWings,
    RequestCallBookingSlot,
    RequestCallConfirm,
  },
  data() {
    return {
      loading: false,
      // eslint-disable-next-line global-require
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.dispatch('requestCall/reset');
    next();
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      prison: state => state.auth.prison,
      stage: state => state.requestCall.stage,
    }),
  },
  mounted() {
    this.$store.commit('requestCall/SET_STAGE', 1); // set to first stage
    this.loading = true;

    // check user
    if (this.user && !this.user.in_cell_book_own_calls) {
      this.$router.push({ name: 'dashboard' });
    }

    this.$store.dispatch('auth/refreshPrison'); // get prison
    this.loading = false;
  },
  methods: {},
}
</script>
